module.exports = __webpack_public_path__ + "cf30f66d2aefe583c8395f3c48e5a5d5.png";


//////////////////
// WEBPACK FOOTER
// ./work/swipolitique/img/swipright.png
// module id = 760
// module chunks = 0